import React from 'react';
import { Image } from '../../Image';
import { ProductPriceRenderer } from './ProductPriceRenderer';
import { OptionalAnchor } from '../shared/OptionalAnchor';
import { ItemProps } from '../types';

/**
 * Default rendering for an individual Hawk Recommendations item
 */
export function DefaultItem({ item, classNameSuffix, onClick }: ItemProps) {
	return (
		<div
			className="roc-product-list__item"
			data-hawk-modelname={item.modelName}
			data-haw-modeltype={item.modelType}
		>
			<OptionalAnchor url={item.url} onClick={onClick}>
				<Image item={item} classNameSuffix={classNameSuffix} />
				<h4 className="roc-product-list__title">
					<em style={{ display: 'block' }}>{item.brand}</em>
					{item.itemName}
				</h4>
				<ProductPriceRenderer item={item} classNameSuffix={classNameSuffix} />
			</OptionalAnchor>
		</div>
	);
}
